__turbopack_context__.v({
  "actionButtonContainer": "NavActions-module-scss-module__iC66ya__actionButtonContainer",
  "signInButton": "NavActions-module-scss-module__iC66ya__signInButton",
  "vibrate": "NavActions-module-scss-module__iC66ya__vibrate",
  "whiteLabeled": "NavActions-module-scss-module__iC66ya__whiteLabeled",
});
